import { useQuery } from '@tanstack/react-query';

import { fetchCurrentSubjectClaims } from '../../api/subjectClaimsApi';
import { useToast } from '../../components/Toast/context/useToast.context';
import { subjectClaims as subjectClaimsMsgs } from '../../../locale/stories.en.locale.json';

import { subjectClaimsQueryKeys } from './subjectClaimsQueryKeys';

export type UseCurrentSubjectClaimsParams = {
  userUuid: string;
  entityUuid: string;
} | null;

export function useCurrentSubjectClaims(params: UseCurrentSubjectClaimsParams) {
  const { toggleToast } = useToast();
  const msgs = subjectClaimsMsgs;

  return useQuery({
    queryKey: params
      ? subjectClaimsQueryKeys.currentClaims(params)
      : ([...subjectClaimsQueryKeys.all, 'currentClaims', 'disabled'] as const),
    queryFn: () => fetchCurrentSubjectClaims(params!),
    enabled: params !== null && !!params.userUuid && !!params.entityUuid,
    onError: () => {
      toggleToast({
        title: msgs?.somethingWentWrongError ?? 'Something went wrong',
        body: msgs?.failedToFetchSubjectClaims ?? 'Failed to fetch subject claims',
        severity: 'error'
      });
    }
  });
}
